if (!('startsWith' in String.prototype)) {
  String.prototype.startsWith = function (str) {
    var index = this.indexOf(str);
    return index == 0;
  };
}
